<template lang="pug">

include ../../../pug/mixins/index

+b-context('header')
  +e.lk(@click='open', v-if='isAuthenticated')
    +e.lk-dropdown(:class!=`{ 'is-opened': opened }`)
      //- +e.top-link
        +e.A.lk-link.img(href="#")
          img(src="/static/images/soc1.png")
        +e.A.lk-link.img(href="#")
          img(src="/static/images/soc2.png")
      div(v-if='!isCompact'): a.calendar__link.modal__link(style="margin-top: 0", :href!='restartUrl', @click.prevent='restart', v-text='i18n.restart')
      div(v-if='!isCompact'): a.calendar__link.modal__link(style="margin-top: 0", :href!='previousUrl', @click.prevent='previous', v-text='i18n.previous', v-if='hasPrevious')
      div(v-if='!isCompact'): a.calendar__link.modal__link(style="margin-top: 0", :href!='cleanUrl', @click.prevent='clean', v-text='i18n.clean')
      +e.A.lk-exit(:href!='exitUrl', @click.prevent='exit', v-text='i18n.exit')

    custom-modal(:title!='i18n.previousConfirm', ref='previousConfirm', :dismissible='false')
      .modal__part(slot="footer")
        a.calendar__link.modal__link2(:href!='previousUrl', v-text='i18n.yes')
        button.calendar__link.modal__link2(@click.prevent='close()', v-text='i18n.no')

    custom-modal(:title!='i18n.restartConfirm', ref='restartConfirm', :dismissible='false')
      .modal__part(slot="footer")
        a.calendar__link.modal__link2(:href!='restartUrl', v-text='i18n.yes')
        button.calendar__link.modal__link2(@click.prevent='close()', v-text='i18n.no')

    custom-modal(:title!='i18n.cleanConfirm', ref='cleanConfirm', :dismissible='false')
      .modal__part(slot="footer")
        a.calendar__link.modal__link2(:href!='cleanUrl', v-text='i18n.yes')
        button.calendar__link.modal__link2(@click.prevent='close()', v-text='i18n.no')

    custom-modal(:title!='i18n.exitConfirm', ref='exitConfirm')
      .modal__part(slot="footer")

        a.calendar__link.modal__link2(:href!='exitUrl', ) {{ _('Выйти') }}
        button.calendar__link.modal__link2(@click.prevent='close()',) {{ _('Остаться') }}

</template>

<script>

import { mapGetters } from 'vuex'
import Translatable from '@shared/mixins/translatable'

export default {
  mixins: [Translatable],
  props: {
    previousUrl: { type: String, required: true },
    restartUrl: { type: String, required: true },
    exitUrl: { type: String, required: true },
    cleanUrl: { type: String, required: true },
    isCompact: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      opened: false,
    }
  },

  inject: ['stagesService', 'productsService'],

  computed: {
    ...mapGetters('user', ['isAuthenticated']),

    hasPrevious() {
      return this.stagesService.getSwitchableStages().length > 1
    }
  },

  methods: {
    previous() {
      this.$refs.previousConfirm.open()
    },
    restart() {
      this.$refs.restartConfirm.open()
    },
    exit() {
      console.error('click', '')
      console.log(this.$refs.exitConfirm)
      this.$refs.exitConfirm.open()
    },
    clean() {
      this.$refs.cleanConfirm.open()
    },

    open() {
      this.opened = true

      let deselector = e => {
        if (this.$el != e.target && $(this.$el).find(e.target).length === 0) {
          this.close()
          $(document).off('click', deselector)
        }
      }
      $(document).on('click', deselector)
    },

    close() {
      this.$refs.previousConfirm.close()
      this.$refs.restartConfirm.close()
      this.$refs.exitConfirm.close()
      this.$refs.cleanConfirm.close()
      this.opened = false
    }
  }
}

</script>


// WEBPACK FOOTER //
// src/js/shared/components/userbar.vue